import type { Action } from "redux";
import type { ThunkAction, ThunkDispatch } from "redux-thunk";

import type WebApiClient from "../api/WebApiClient.ts";
import type { IAppState } from "./reducer.ts";

export function createReducer(initialState, reducerMap) {
  // reducerMap["undefined"]: Reducer contains an 'undefined' action type.
  // Have you misspelled a constant? Or the order of imports should be optimized ?
  return (state = initialState, action) => {
    const reducer = reducerMap[action.type];

    if (reducer) {
      return reducer(state, action.payload, action.error);
    }

    return state;
  };
}

export type ReduxAction<T> = ThunkAction<T, IAppState, WebApiClient, Action<string>>;

export type ReduxDispatch = ThunkDispatch<IAppState, WebApiClient, Action<string>>;
